import Footer from "../components/footer";
import Header from "../components/header";
import SideNavReSeller from "../components/sidenavReSeller";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";

const ReSellerArtistList = () => {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));

    const [dataArtistList, setDataArtistList] = useState([]);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/UsersList/Get-GetArtistListByReSellerID?ownerID='+ userInfo.user_id, setDataArtistList);

    }, [dataArtistList]);

const columns = [
    {
        name: "",
        cell: (row) => <img className="m-2" src={`../images/profile/${row.image}`} alt=" " width="80px" />,
        width: "110px"

    },
    {
        name: "Artist",
        selector: (row) => row.username,
        width: "200px"
    },
    /* {
        name: "Email",
        selector: (row) => row.email,
        width: "250px"
    },
    {
        name: "Mobile",
        selector: (row) => row.mobile,
        width: "200px"
    },
    {
        name: "Address",
        selector: (row) => row.address,
        width: "250px"
    } */
];


    return (
        <>
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNavReSeller />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='My Artist List' icon='bi bi-suit-heart-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">My Artist List</div>
                                        <div className="card-body">

                                        <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={dataArtistList}
                                                    pagination
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
        </>
    );
};
export default ReSellerArtistList;